<template>
  <Teleport to="body">
    <Toast
      v-for="toast in toasts"
      :key="toast.id"
      :ref="(instance) => instance?.el && (toast.el = instance.el)"
      :closing="toast.closing"
      :offset="toast.offset"
      :timeout="toast.timeout"
      :type="toast.type"
      @close="closeToast(toast.id)"
    >
      <component :is="toast.component" v-bind="toast.props" />
    </Toast>
  </Teleport>
</template>

<script setup>
import Toast from "./Toast.vue";
import { closeToast, toasts } from "./toasts";
</script>
